<!--
component: ListElvAddress
author: Ken Nakamura
description: 定期報告住所検索結果リスト
-->
<template>
  <section>
    <v-data-table
      :headers="headers" :items="kenkaku"
      :fixed-header="true" height="calc(100vh - 20em)"
      mobile-breakpoint="0"
      disable-pagination hide-default-footer dense
      :single-select="true" item-key="daichoId"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items"
            @click="selectRow(item)"
            :id="item.id"
            :key="index"
            :class="{selected:item.active}"
            class="default"
          >
            <td>{{item.seiriNo}}</td>
            <td>{{item.buildName}}</td>
            <td>{{item.address}}</td>
            <td>{{item.categoryName}}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { dbglog, dateTextToWareki } from '../common/utils'

export default {
  data: () => {
    return {
      headers: [
        {
          text: '整理番号',
          value: 'seiriNo'
        },
        {
          text: '建築物名称',
          value: 'buildName'
        },
        {
          text: '所在地',
          value: 'address'
        },
        {
          text: '種別',
          value: 'categoryName'
        }
      ],
    }
  },
  props: {
  },
  mounted () {
    this.scrollToSelection();
  },
  computed: {
    kenkaku () {
      return this.$store.state.summaries;
    },
  },
  methods: {
    /**
     * 日付の和暦変換
     * @param {Date} date 変換する日付
     * @return {String} 和暦表現に変換された文字列を返す
     */
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from utils.js
    },
    /**
     * 一覧でクリックされた行を選択
     * @param {GaiyoSummary} target 選択する概要データ
     */
    selectRow (target) {
      dbglog(`ListTeihoAddress.selectRow(${target.id})`);
      this.$store.commit('setGaiyoId', target.id);
      this.$store.commit('setUkeNo', target.seiriNo);
      dbglog(`ListTeihoAddress.selectRow(${this.$store.state.gaiyoId})`);
      this.kenkaku.forEach((k) => {
        k.active = (k === target);
      });
    },
    /**
     * 選択されている物件がリスト中央に表示されるようにスクロールする
     */
    scrollToSelection () {
      if (this.$store.state.gaiyoId) {
        const tr = document.getElementById(this.$store.state.gaiyoId);
        tr.scrollIntoView({ block: 'center' });
      }
    },
  },  
}
</script>
<style scoped src="@/styles/table-styles.css">
</style>